import { type ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';
import useClickOutside from '@pasqal/core/hooks/useClickOutside';
import Dialog from '../Dialog/Dialog';
import './Modal.css';

interface ModalProps {
  title: string;
  isVisible: boolean;
  onClose: () => void;
  body?: ReactNode;
  footer?: ReactNode;
}

export default function Modal({
  title,
  isVisible,
  onClose,
  body,
  footer
}: ModalProps) {
  const modalRef = useRef<HTMLDialogElement>(null);

  useClickOutside({
    el: modalRef,
    handler: (e) => {
      e.stopPropagation();
      onClose();
    },
    isOpen: isVisible,
    isActive: isVisible
  });

  return createPortal(
    <div
      className="ModalOverlay"
      style={{ display: isVisible ? undefined : 'none' }}
    >
      <Dialog
        ref={modalRef}
        title={title}
        onClose={onClose}
        body={body}
        footer={footer}
      />
    </div>,
    document.body
  );
}
